import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {ReplyIcon} from '@primer/octicons-react'
import {useRelativeNavigation} from '../hooks/use-relative-navigation'
import type {HistoryComparisonRoutePayload} from '@github-ui/repos-rules-types/rules-types'
import {LinkButton, RelativeTime} from '@primer/react'
import {Link} from '@github-ui/react-router'
import {GitHubAvatar} from '@github-ui/github-avatar'
import type {SafeHTMLString} from '@github-ui/safe-html'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'
import {useRuleStrings} from '../hooks/use-rule-strings'

import styles from './HistoryComparisonPage.module.css'

export const HistoryComparisonPage = () => {
  const {navigate, resolvePath} = useRelativeNavigation()
  const {ruleset, diffHtml, history} = useRoutePayload<HistoryComparisonRoutePayload>()
  const {rulesetOrPolicy} = useRuleStrings()

  return (
    <>
      <div className={styles.ComparisonContainer}>
        <div className={styles.ComparisonHeader}>
          <Link to={resolvePath('../../../..')}>Rulesets</Link>
          <span>/</span>
          <Link to={resolvePath('../../..')}>
            <span className={styles.ComparisonTitle}>{ruleset.name}</span>
          </Link>
          <span>/</span>
          <Link to={resolvePath('../..')}>
            <span className={styles.ComparisonTitle}>History</span>
          </Link>
          <span>/</span>
          <span>Compare</span>
        </div>
      </div>
      <div className={styles.ComparisonContent}>
        <div className={styles.LeftPanel}>
          <div className={styles.RightPanel}>
            <GitHubAvatar src={history.updated_by.static_avatar_url} className={styles.UserAvatar} />
            <span>{history.updated_by.display_login}</span>
            <div className={styles.AvatarContainer}>
              <span>edited</span>
              <RelativeTime datetime={history.created_at} />
            </div>
          </div>
          {!history.is_current ? (
            <LinkButton
              aria-label={`Restore ${rulesetOrPolicy}`}
              onClick={async () => {
                navigate('../../..', `history_id_to_restore=${history.id}`)
              }}
              href={''}
              variant="invisible"
              size={'small'}
              leadingVisual={ReplyIcon}
              className={styles.ViewChangesButton}
            >
              <span className={styles.ChangesSummary}>Restore</span>
            </LinkButton>
          ) : null}
        </div>
      </div>
      <div className={styles.ChangesContainer}>
        {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
        <div className="prose-diff no-level-zero-box-shadow">
          <VerifiedHTMLDiv
            className="markdown-body"
            // Extract certain pre styles from typical markdown body class
            style={{
              overflow: 'auto',
              fontSize: '85%',
              lineHeight: 1.45,
              fontFamily: 'var(--fontStack-monospace)',
            }}
            // eslint-disable-next-line @github-ui/github-monorepo/no-cast-as-safe-html-string -- HTML is sanitized server-side. TODO: Move type assertion to data ingress point.
            html={diffHtml as SafeHTMLString}
          />
        </div>
      </div>
    </>
  )
}
